/**
 * Firestore rejects `undefined` outright — a single optional field left unset fails the whole
 * write with a message that names the field and not the document. Every type in `types.ts` has
 * optional fields, so this runs on the way in, in the app's store and in `functions/` alike.
 *
 * Strips undefined rather than converting it to null, because null is a value the domain uses
 * deliberately: `keeperDeadline: null` means "no deadline set", which is not the same as a
 * deadline nobody has written yet.
 */
export function clean<T>(value: T): T {
  if (Array.isArray(value)) return value.map((v) => clean(v)) as unknown as T;
  if (value && typeof value === 'object') {
    const out: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(value as Record<string, unknown>)) {
      if (v !== undefined) out[k] = clean(v);
    }
    return out as T;
  }
  return value;
}
